function isError(error: unknown): error is Error {
  return error instanceof Error;
}

export default function toError(maybeError: unknown): Error {
  if (isError(maybeError)) {
    return maybeError;
  }

  try {
    return new Error(JSON.stringify(maybeError));
  } catch {
    // fallback in case there's an error stringifying the maybeError
    // like with circular references for example.
    return new Error(String(maybeError));
  }
}
